
        <div class="cover">
            <div>
                You have been logged out. Goodbye!
                <div class="mt-4">
                    <a class="login btn btn-primary" href="/">Login</a>
                </div>
            </div>
        </div>
    